import { render, staticRenderFns } from "./ButtonRemind.vue?vue&type=template&id=7195c9ff&scoped=true"
import script from "./ButtonRemind.vue?vue&type=script&lang=js"
export * from "./ButtonRemind.vue?vue&type=script&lang=js"
import style0 from "./ButtonRemind.vue?vue&type=style&index=0&id=7195c9ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7195c9ff",
  null
  
)

export default component.exports